<template>
  <a
    :href="href"
    class="d-inline-flex align-items-center badge p-1 px-md-2 badge-pill badge-gray-300 text-dark h6 mb-0"
    :class="variant === 'small' ? '' : 'py-md-2'"
  >
    <slot></slot>
    <ChevronRight class="svg-16 ml-1" />
  </a>
</template>

<script>
import ChevronRight from "../../../icons/atalanda/chevron-right.svg";

export default {
  components: {
    ChevronRight,
  },
  props: {
    href: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      required: false,
      default: "normal",
    },
  },
};
</script>
